<template>
  <head>
    <title>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</title>
    <meta
      name="description"
      :content="$i18n.locale === 'ar' ? data.title_ar : data.title_en"
    />
  </head>
  <NavbarComponent />
  <main id="main">
    <!-- ======= Breadcrumbs ======= -->
    <div
      class="breadcrumbs d-flex align-items-center"
      style="background-image: url('assets/img/ourservice.jpg')"
    >
      <div
        class="container position-relative d-flex flex-column align-items-center"
      >
        <h2>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</h2>
        <ol>
          <li>
            <a href="/">{{ $t("home") }}</a>
          </li>
          <li>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</li>
        </ol>
      </div>
    </div>
    <!-- End Breadcrumbs -->
    <!-- ======= About Section ======= -->
    <section id="services" class="about">
      <div class="container" data-aos="fade-up">
        <div class="row gy-4" data-aos="fade-up">
          <div
            class="col-lg-4 d-flex align-items-center justify-content-center"
          >
            <img
              :src="$store.state.server + data.img"
              class="img-fluid"
              alt=""
              style="border-radius: 20px"
            />
          </div>
          <div
            class="col-lg-8 d-flex align-items-center justify-content-center"
          >
            <div class="content ps-lg-5">
              <h2>{{ $i18n.locale === "ar" ? data.name_ar : data.name_en }}</h2>
              <h4 class="my-3">
                {{ $i18n.locale === "ar" ? data.title_ar : data.title_en }}
              </h4>
              <ul>
                <template v-if="$i18n.locale === 'ar'">
                  <li v-for="(item, index) in description_ar" :key="index">
                    {{ item }}
                  </li>
                </template>
                <template v-else>
                  <li v-for="(item, index) in description_en" :key="index">
                    {{ item }}
                  </li>
                </template>
              </ul>
              <p class="title-route my-4" v-if="isValidLink">
                <a :href="data.link" target="_blank">
                  {{
                    $i18n.locale == "ar" ? "الانتقال إلى الرابط" : "Go to link"
                  }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End About Section -->
  </main>
</template>

<script>
import NavbarComponent from "@/components/NavbarComponent.vue";
import store from "@/store";
import axios from "axios";
export default {
  name: "service-view",
  components: {
    NavbarComponent,
  },
  data() {
    return {
      id: "",
      data: [],
      description_ar: [],
      description_en: [],
    };
  },
  computed: {
    isValidLink() {
      if (!this.data || !this.data.link) return false;

      const link = String(this.data.link).trim().toLowerCase();
      return link !== "" && link !== "null";
    },
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_product_id/" + this.id)
        .then((response) => {
          this.data = response.data;

          // normalize description_ar
          try {
            const parsedAr = JSON.parse(this.data.description_ar);
            this.description_ar = Array.isArray(parsedAr)
              ? parsedAr
              : [parsedAr]; // if it's a single string
          } catch (e) {
            this.description_ar = this.data.description_ar
              ? [this.data.description_ar]
              : [];
          }

          // normalize description_en
          try {
            const parsedEn = JSON.parse(this.data.description_en);
            this.description_en = Array.isArray(parsedEn)
              ? parsedEn
              : [parsedEn];
          } catch (e) {
            this.description_en = this.data.description_en
              ? [this.data.description_en]
              : [];
          }

          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    let params = new URL(document.location.toString()).searchParams;
    this.id = params.get("id");
    this.getData();
  },
};
</script>

<style scoped>
.title-route a {
  color: var(--color-secondary);
  transition: 0.3s;
}

.title-route a:hover {
  color: var(--color-primary);
}
ul {
  list-style: none;
  padding-left: 1.5rem;
  color: var(--color-primary);
}

li {
  font-size: 18px !important;
}

li::before {
  content: "•"; /* or "\2022" */
  color: var(--color-primary);
  display: inline-block;
  width: 1rem;
  margin-left: -1rem;
}
</style>
